import { Conditions } from "@pages/booking/Conditions";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import { Stepper } from "./Stepper";
import { routes } from "@routes";
import { Journey, Travel } from "@gen/travel/v1/common_pb";
import { DAP } from "@gen/dap/v1/dap_pb";
import { getTravel } from "@services/travel";
import { getDAP } from "@services/dap";
import { Spinner } from "@thetreep/ui";

export function Exchange() {
  const location = useLocation();
  const { travelId, journeyId } = useParams();

  const [travel, setTravel] = useState<Travel>();
  const [journey, setJourney] = useState<Journey>();
  const [dap, setDap] = useState<DAP>();

  // Routes pour lesquelles les conditions ne doivent pas être affichées
  const confirmationRoutes = [routes.CART, routes.CONFIRMATION, routes.PAYMENT];
  const shouldShowConditions = !confirmationRoutes.includes(location.pathname);

  async function fetchTravel(id: string) {
    try {
      const travel = await getTravel(id);
      setTravel(travel.travel);
      if (!travel.travel) {
        console.error("travel not found");
        return;
      }

      const beneficiary = travel.travel.passengers[0];
      const dap = await getDAP(travel.travel.dapNumber, beneficiary.lastName);
      setDap(dap.dap);
    } catch (error) {
      console.error("Error fetching travel or DAP:", error);
    }
  }

  useEffect(() => {
    if (!travelId) return;
    // oxlint-disable-next-line react-hooks/set-state-in-effect
    fetchTravel(travelId);
  }, [travelId]);

  const [prevTravel, setPrevTravel] = useState(travel);
  if (travel !== prevTravel) {
    setPrevTravel(travel);
    if (travel) {
      switch (journeyId) {
        case travel.outward?.id:
          setJourney(travel.outward);
          break;
        case travel.inward?.id:
          setJourney(travel.inward);
          break;
        default:
          throw `journey ${journeyId} not found`;
      }
    }
  }

  if (!travel || !journey || !dap) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="relative px-5 lg:px-0 mx-auto w-full ">
      <Stepper />
      <div className="flex flex-col my-10 justify-center gap-4 lg:flex-row lg:gap-12 lg:my-20 w-full lg:px-5">
        {shouldShowConditions && <Conditions dap={dap} />}
        <div
          className={`max-w-[936px] w-full mt-28 md:mt-[180px] lg:mt-12 ${
            !shouldShowConditions ? "mx-auto" : ""
          }`}
        >
          <Outlet context={{ dap, travel, journey }} />
        </div>
      </div>
    </div>
  );
}
